export { UserProfileCard as default, UserProfileCard } from './UserProfileCard';
export type { UserProfileCardProps } from './UserProfileCard';